export default class ResearchAxis {
  public id: number | undefined = undefined;
  public organization_id: number | undefined = undefined;
  public label: string | null = null;
}
